<template>
  <section
    id="checkoutHotelDetails"
    :class="[openClass, 'expandable_section']"
  >
    <h2
      class="expandable_header"
      @click="updateSection(sectionName)"
    >
      {{ number }}. {{ $t('checkout.hotelDetails.sectionTitle') }}
    </h2>
    <div class="expandable_content">
      <div class="checkout-hotel">
        <p>{{ $t('checkout.hotelDetails.description') }}</p>
        <!-- Loop begins -->
        <div
          v-for="(room, index) in roomInformation"
          :key="index"
          class="room-information"
        >
          <p>
            <b>{{ $t('checkout.hotelDetails.room', {number: index + 1}) }}</b>
            {{ room.hotelName }}
          </p>
          <p
            v-if="room.checkIn && room.checkOut"
            class="small"
          >
            {{ room.checkIn }} - {{ room.checkOut }}
          </p>
          <div class="hotel-details-checkbox">
            <input
              :id="`billing-name-${index}`"
              v-model="sameAsBilling[index]"
              type="checkbox"
            >
            <label
              :for="`billing-name-${index}`"
              class="hotel-details-label"
            >
              Same as Billing Name
            </label>
          </div>
          <div class="required-field">
            <input
              v-model="room.name"
              v-validate="'required'"
              class="checkout-address"
              :name="`name-${index}`"
              type="text"
              placeholder="*Name for Reservation"
              :class="{ 'required': errors.has(`name-${index}`) && !sameAsBilling[index] }"
              :disabled="sameAsBilling[index]"
            >
            <span
              v-show="errors.has(`name-${index}`) && !sameAsBilling[index]"
              class="error"
            >
              {{ errors.first(`name-${index}`) }}
            </span>
          </div>
        </div>
        <!-- Loop Ends -->
      </div>
      <button
        class="continue-button btn btn-primary"
        @click="checkRequiredFields"
      >
        {{ $t('cookie.continue') }}
      </button>
    </div>
  </section>
</template>

<script>
import Api from '../cart/cart_api'
import { mapMutations, mapState, mapActions } from 'vuex'
import FetchCall from '../local_fetch_call'

export default {
  props: {
    number: {
      default: null,
      required: false,
      type: Number
    },
  },

  data() {
    return {
      orderItems: [],
      reservations: [],
      sectionName: 'hotel',
      sectionNext: 'review',
      sameAsBilling: [],
      roomInformation: [],
    }
  },

  computed: {
    ...mapState('checkout', {
      billing: state => state.billing,
      section: state => state.section
    }),
    selected() {
      return this.section == this.sectionName
    },
    openClass() {
      return (this.selected) ? 'open' : ''
    }
  },

  watch: {
    roomInformation() {
      this.updatePaymentFields({ roomInformation: this.roomInformation })
    },
    sameAsBilling() {
      this.updateReservationName()
    }
  },

  async created() {
    let order = await Api.getOrder()
    this.orderItems = order.items

    await this.getOrderReservations()
    this.getRoomInformation()
  },

  methods: {
    ...mapMutations('checkout', [
      'updatePaymentFields',
      'updateHotelInCart'
    ]),
    ...mapActions('checkout', ['updateSection']),
    async getRoomInformation() {
      this.orderItems.forEach(item => {
        for (let i = 0; i < item.room_quantity; i++) {
          let index = this.reservations.map(x => x.order_item_id).indexOf(item.id)
          let reservation = this.reservations.splice(index, 1)[0]
          this.roomInformation.push({
            id: reservation.reservation_id,
            orderItemId: item.id,
            numberOfAdults: 2,
            name: reservation.name,
            hotelName: item.hotel_display_name,
            checkIn: item.h4h_hotel_attributes.hotel_check_in_date,
            checkOut: item.h4h_hotel_attributes.hotel_check_out_date
          })
          this.sameAsBilling.push(false)
        }
      })

      this.roomInformation.length > 0 ?
        this.updateHotelInCart(true) :
        this.updateHotelInCart(false)
    },
    async getOrderReservations() {
      let res = await FetchCall.fetchWithoutLocale(
        '/api/checkout_hotel_reservations',
        'GET',
        null
      )
      if (!res.reservations) return

      this.reservations = res.reservations
    },
    updateReservationName() {
      for (let i = 0; i < this.sameAsBilling.length; i ++) {
        if (this.sameAsBilling[i]) {
          let name = `${this.billing.firstName} ${this.billing.lastName}`
          this.roomInformation[i].name = name
        }
      }
    },
    async checkRequiredFields() {
      let isValid = await this.$validator.validate()
      if (isValid) {
        this.updateSection(this.sectionNext)
      } else {
        for (let field of this.$validator.fields) {
          field.update({ events: 'input|blur'})
        }
      }
    }
  }
}
</script>
